import React, { useState } from 'react';
import type { ReactNode } from 'react';

export interface CollapsiblePanelProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function CollapsiblePanel({
  title,
  children,
  defaultOpen = false,
}: CollapsiblePanelProps): React.ReactElement {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="collapsible-panel">
      <button
        className="collapsible-panel__header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        type="button"
      >
        <span className="collapsible-panel__title">{title}</span>
        <span className="collapsible-panel__icon" aria-hidden="true">
          {isOpen ? '▾' : '▸'}
        </span>
      </button>
      {isOpen && (
        <div className="collapsible-panel__content">
          {children}
        </div>
      )}
    </div>
  );
}
